import React from "react";
import { FieldRenderer } from "../form/FieldRenderer";
import type { FormSectionProps } from "./types";

const FormSection: React.FC<FormSectionProps> = ({
  title,
  fields,
  className,
}) => {
  return (
    <div className={className}>
      <h3 className="text-[15px] font-bold text-[#2B2B2B]">{title}</h3>

      <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-2">
        {fields.map((f) => (
          <FieldRenderer key={f.name} cfg={f} />
        ))}
      </div>
    </div>
  );
};

export default FormSection;
